import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import axios from 'axios';

const LineGraph = ({ data, selectedVariable, variable }) => {
    const chartRef = useRef(null);
    const [years, setYears] = useState([]);

    const yValues = data.map(yearData => {
        if (yearData.length === 0) return null;

        let value = yearData[0][selectedVariable];
        if (selectedVariable.includes('income')) {
            value = value / (selectedVariable === 'avg_ann_income_indv' ? 100 : 10);
        }
        return value;
    });

    // Fetch available years
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/db/years`)
            .then((response) => {
                setYears(response.data);
            })
            .catch((error) => {
                console.error('Error fetching years:', error);
            });
    }, []);    

    useEffect(() => {
        let chartInstance = null;
        const ctx = chartRef.current.getContext('2d');

        // Destroy any existing chart instance before creating a new one
        if (chartInstance) {
            chartInstance.destroy();
        }

        chartInstance = new Chart(ctx, {
            type: 'line',
            data: {
                datasets: [{
                    label: variable.label,
                    data: yValues,
                    spanGaps: true,
                    tension: 0,
                    borderColor: '#1976d2',
                    fill: false,
                    interpolate: false,
                    segment: {
                        borderWidth: 2,
                    }
                }],
                labels: years, // Use dynamically fetched years as labels
            },
            options: {
                responsive: true,
                elements: {
                    point: {
                        radius: 4,
                    },
                    line: {
                        tension: 0,
                        stepped: false,
                        cubicInterpolationMode: false
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Year'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: variable.label
                        },
                        ticks: {
                            callback: function(value) {
                                if (selectedVariable.includes('income')) {
                                    return `$${value.toLocaleString()}`;
                                }
                                return `${value.toFixed(2)}%`;
                            }
                        }
                    }
                }
            }
        });

        return () => {
            if (chartInstance) {
                chartInstance.destroy();
            }
        };
    }, [yValues, variable, selectedVariable, years]);

    return (
        <div style={{ width: '100%', height: '400px' }}>
            <canvas ref={chartRef}></canvas>
        </div>
    );
};

export default LineGraph;